module.exports = __webpack_public_path__ + "static/media/study 201113.73ae7bfd.png";